import { usePageTitle } from '~hooks/usePageTitle';

import LoginPageContainer from '../containers/loginPageContainer';

const LoginLaunchPage = () => {
	usePageTitle('login');
	return <LoginPageContainer />;
};

export default LoginLaunchPage;
